module.exports = __webpack_public_path__ + "img/bg-firstBar.dd42f025.jpg";